import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  GET_ACCESSTOKEN_LINE: function (state, payload) {
    state.accesstokenLine = payload
  },
  SET_DATAREGISTERLINE: function (state, payload) {
    state.dataRegister = { ...payload }
    state.dataRegister.facebook_id = null
    state.dataRegister.line_id = payload.sub
  },
  SET_DATAREGISTERFB: function (state, payload) {
    state.dataRegister = { ...payload }
    state.dataRegister.line_id = null
    state.dataRegister.facebook_id = payload.id
  },
  CLEAR_DATAREGISTER: function (state, payload) {
    state.dataRegister = { ...payload }
    state.dataRegister.facebook_id = payload
    state.dataRegister.line_id = payload
  },
  SET_ISAUTHENTICATED: function (state, payload) {
    localStorage.setItem('isAuthenticated', payload)
    state.isAuthenticated = payload
  },
  SET_SHOPPROFILE: function (state, payload) {
    state.businessProfile = payload
  },
  EDIT_ACCOUNT: function (state, payload) {
    localStorage.setItem('profile', JSON.stringify(payload))
    state.profile = payload
  }
}
